module.exports = __webpack_public_path__ + "static/aCube-e79dfc019c87fabf72600ac2877b7458.mp4";